import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AppBreadcrumbService } from './app.breadcrumb.service';
import { TranslationService } from 'src/app/core/base/services/translation.service';
import { Subscription } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { AppMainComponent } from 'src/app/app.main.component';
import { AppGlobals } from 'src/app/app.globals';

interface Language {
    code: string,
    default: boolean,
    name: string,
	flag: string;
	active?: boolean;
}

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './app.breadcrumb.component.html',
    styleUrls: ['./app.breadcrumb.component.scss']
})
export class AppBreadcrumbComponent implements OnInit, OnDestroy {
    languages: Language[];
    language: Language;
    subscription: Subscription;
    centerLabelSubscription: Subscription;
    items: MenuItem[];
    home: MenuItem;
    search: string;
    centerLabel: string = "";

    constructor(private translate: TranslationService, private changeDetectorRef: ChangeDetectorRef, public breadcrumbService: AppBreadcrumbService, public appMain: AppMainComponent) {
        this.languages = AppGlobals.getParam('locales');
        this.subscription = breadcrumbService.itemsHandler.subscribe(response => {
            this.items = response;
        });
        this.centerLabelSubscription = breadcrumbService.centerLabelHandler.subscribe(label => {
            this.centerLabel = label || "";
        });
        
        this.home = { icon: 'pi pi-home', routerLink: '/' };
    }

    ngOnInit(): void {
        this.setSelectedLanguage();
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        if (this.centerLabelSubscription) {
            this.centerLabelSubscription.unsubscribe();
        }
    }

    public changeLanguage(event: any) {
        let context = this;
        if (typeof event.value.code != 'undefined' && event.value.code != null) {
            context.setLanguage(event.value.code);
            location.reload();
        }
    }

    /**
	 * Set language
	 *
	 * @param lang: any
	 */
	setLanguage(lang) {
		this.languages.forEach((language: Language) => {
			if (language.code === lang) {
				language.active = true;
				this.language = language;
			} else {
				language.active = false;
			}
		});
		this.translate.setLanguage(lang);
	}

	/**
	 * Set selected language
	 */
	setSelectedLanguage(): any {
		this.setLanguage(this.translate.getSelectedLanguage());
	}
}
